var GLESAssetBase = /** @class */ (function () {
    function GLESAssetBase(context, id) {
        this._context = context;
        this._id = id;
    }
    Object.defineProperty(GLESAssetBase.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    return GLESAssetBase;
}());
export { GLESAssetBase };
